import { render, staticRenderFns } from "./risk-group-relative-modal.vue?vue&type=template&id=2548045c&scoped=true"
import script from "./risk-group-relative-modal.vue?vue&type=script&lang=js"
export * from "./risk-group-relative-modal.vue?vue&type=script&lang=js"
import style0 from "./risk-group-relative-modal.vue?vue&type=style&index=0&id=2548045c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2548045c",
  null
  
)

export default component.exports